import { AfterViewInit, Component, OnInit, ViewEncapsulation } from '@angular/core';
import SwiperCore, {
  Autoplay,
  EffectCoverflow,
  EffectCube,
  EffectFade,
  EffectFlip,
  Navigation,
  Pagination,
  Swiper,
  SwiperOptions,
  Grid
} from "swiper";
import * as AOS from 'aos';
import { Router } from '@angular/router';
import { AppService } from '@services/app.service';
import { Subject, takeUntil } from 'rxjs';
import { CategoryDetails } from '@/modals/category-details';
import { ProductDetails } from '@/modals/product-details';
import { ConfigService } from '@services/config.service';
import { NgxSpinnerService } from 'ngx-spinner';
import 'swiper/css/bundle';

SwiperCore.use([Autoplay, Pagination, Navigation, EffectFade, EffectCube, EffectCoverflow, EffectFlip, Grid]);
@Component({
  selector: 'app-website',
  templateUrl: './website.component.html',
  styleUrl: './website.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class WebsiteComponent implements OnInit, AfterViewInit {

  destroy$: Subject<boolean> = new Subject<boolean>();

  // api-variables
  productDetails: ProductDetails[] = [];
  allProductDetails: ProductDetails[] = []
  // category
  categoryDetails: CategoryDetails[] = [];
  allCategoryDetails: CategoryDetails[] = [];
  // image 
  endpoint: string = ''
  // category selection flag
  isCategorySelected: boolean = false;
  selectedCategoryId: any = 'all';

  // search
  productSearchQuery: string = '';
  categorySearchQuery: string = '';
  hasScrolledToSearch: boolean = false;


  constructor(
    private router: Router,
    private config: ConfigService,
    private appService: AppService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit(): void {
    AOS.init();
    console.log("this.appService")
    this.getAllProducts();
    this.getCategoryDetails()
    this.endpoint = this.config.getConfig().END_POINT;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      new Swiper('.mySwiper', {
        slidesPerView: 5,
        grid: {
          rows: 2,
          fill: 'row',
        },
        spaceBetween: 20,
        navigation: {
          nextEl: '.new-swiper-button-next',
          prevEl: '.new-swiper-button-prev',
        },
        pagination: {
          el: '.new-swiper-pagination',
          type: 'fraction',
          clickable: true,
          bulletClass: 'custom-bullet',
          bulletActiveClass: 'custom-bullet-active'
        },
        breakpoints: {
          320: {
            slidesPerView: 2,
            grid: { rows: 2, fill: 'row' }
          },
          576: {
            slidesPerView: 2,
            grid: { rows: 2, fill: 'row' }
          },
          768: {
            slidesPerView: 3,
            grid: { rows: 2, fill: 'row' }
          },
          992: {
            slidesPerView: 4,
            grid: { rows: 2, fill: 'row' }
          }
        }
      });
    }, 0);
  }





  mainBanner: SwiperOptions = {
    slidesPerView: 2,
    spaceBetween: 0,
    loop: true,
    speed: 3000,
    effect: 'slide',
    autoplay: {
      delay: 4000,
      disableOnInteraction: true,
    },
    navigation: {
      nextEl: '.banner-swiper-button-next',
      prevEl: '.banner-swiper-button-prev',
    },
    breakpoints: {
      1440: { slidesPerView: 1 },
      1024: { slidesPerView: 1 },
      700: { slidesPerView: 1 },
      500: { slidesPerView: 1 },
      400: { slidesPerView: 1 },
      300: { slidesPerView: 1 },
    },
  };



  categoryConfig: SwiperOptions = {
    slidesPerView: 2,
    spaceBetween: 20,
    loop: false,
    effect: 'slide',
    pagination: {
      el: '.cat-swiper-pagination',
      type: 'fraction',
      clickable: true,
      bulletClass: 'custom-bullet',
      bulletActiveClass: 'custom-bullet-active'
    },
    breakpoints: {
      1440: {
        slidesPerView: 7,
      },
      1024: {
        slidesPerView: 6,
      },
      700: {
        slidesPerView: 4,
      },
      500: {
        slidesPerView: 3,
      },
      400: {
        slidesPerView: 2,
      },
      300: {
        slidesPerView: 2,
      },
    },
    navigation: {
      nextEl: '.cat-swiper-button-next',
      prevEl: '.cat-swiper-button-prev',
    },
  };


  testimonialConfig: SwiperOptions = {
    slidesPerView: 2,
    spaceBetween: 20,
    loop: true,
    speed: 1500,
    effect: 'slide',
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    breakpoints: {
      1440: { slidesPerView: 1 },
      1024: { slidesPerView: 1 },
      700: { slidesPerView: 1 },
      500: { slidesPerView: 1 },
      400: { slidesPerView: 1 },
      300: { slidesPerView: 1 },
    },
    navigation: {
      nextEl: '.testimonial-next',
      prevEl: '.testimonial-prev',
    },
  };



  brandImagesConfig: SwiperOptions = {
    slidesPerView: 2,
    spaceBetween: 20,
    loop: true,
    speed: 1500,
    effect: 'slide',
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    breakpoints: {
      1440: { slidesPerView: 7 },
      1024: { slidesPerView: 6 },
      700: { slidesPerView: 4 },
      500: { slidesPerView: 3 },
      400: { slidesPerView: 2 },
      300: { slidesPerView: 2 },
    },
    navigation: {
      nextEl: '.testimonial-next',
      prevEl: '.testimonial-prev',
    },
  };




  bannerValue = [
    {
      "image": "../../../assets/img/new/favicon_io/banner-1-at.png",
    },
    {
      "image": "../../../assets/img/new/favicon_io/banner-2-at.png",
    },
    {
      "image": "../../../assets/img/new/favicon_io/banner-3-at.png",
    }
  ]



  // testimonial = [
  //   {
  //     "image": "assets/img/bottom-banner-3.jpg",
  //     "description": "These are great quality eye glasses and I love how you can choose the lens power for each eye. I searched the internet for a while and this is the only company I found that did that.",
  //     "name": "LEAH JOHN",
  //     "role": "Fashion"
  //   },
  //   {
  //     "image": "assets/img/bottom-banner-2.jpg",
  //     "description": "These are great quality eye glasses and I love how you can choose the lens power for each eye. I searched the internet for a while and this is the only company I found that did that.",
  //     "name": "LEAH JOHN",
  //     "role": "Fashion"
  //   },
  //   {
  //     "image": "assets/img/bottom-banner-1.jpg",
  //     "description": "Find Your Fit These are great quality eye glasses and I love how you can choose the lens power for each eye.",
  //     "name": "Get up to 50% off on top brands",
  //     "role": "Fashion"
  //   },
  // ]

  testimonial = [
    {
      name: "Ravi Mehta",
      role: "Workshop Owner, Chennai",
      image: "https://randomuser.me/api/portraits/men/45.jpg",
      description: "The Bosch GSB drill I purchased from this store has significantly improved our job turnaround time. Reliable and powerful—exactly what we needed in a busy workshop environment."
    },
    {
      name: "Sujatha Iyer",
      role: "Fabrication Engineer, Coimbatore",
      image: "https://randomuser.me/api/portraits/women/44.jpg",
      description: "Excellent service and quick delivery! The machine tools are genuine and competitively priced. Our team is happy with the precision of the grinding machine."
    },
    {
      name: "Prakash Anand",
      role: "Auto Service Technician, Bangalore",
      image: "https://randomuser.me/api/portraits/men/28.jpg",
      description: "I’ve been ordering cutting tools and drills here for months—every single one performs exactly as promised. Great support from the sales team too!"
    },
    {
      name: "Deepika Menon",
      role: "CNC Machine Operator, Hyderabad",
      image: "https://randomuser.me/api/portraits/women/65.jpg",
      description: "Finding high-quality tools for CNC machining used to be a challenge. Now I just visit this website. Fast, professional, and trustworthy service."
    },
    {
      name: "Mohammed Farooq",
      role: "Lathe Technician, Pune",
      image: "https://randomuser.me/api/portraits/men/33.jpg",
      description: "This is my go-to store for power tools and lathe accessories. The variety, quality, and delivery speed are unmatched. Highly recommended!"
    }
  ];




  blogPosts = [
    {
      title: "Top 5 Bosch Tools for Workshop Efficiency",
      author: "Admin",
      category: "Tool Reviews",
      tag: "Bosch",
      image: "https://belaltheme.com/Mp/Azapp/assets/images/blog/1.jpg",
      description: "Explore the most reliable and high-performing Bosch tools that can transform your workshop's productivity and safety standards."
    },
    {
      title: "How to Maintain Your CNC Machines",
      author: "Tech Editor",
      category: "Maintenance",
      tag: "CNC",
      image: "https://belaltheme.com/Mp/Azapp/assets/images/blog/2.jpg",
      description: "Regular maintenance can extend the lifespan of your CNC machines. Here are some practical tips to follow monthly."
    },
    {
      title: "Why Precision Tools Matter in Fabrication",
      author: "Engineer Desk",
      category: "Fabrication",
      tag: "Precision",
      image: "https://belaltheme.com/Mp/Azapp/assets/images/blog/3.jpg",
      description: "Choosing the right precision tools ensures better results and fewer errors in large-scale industrial fabrication tasks."
    }
  ];




  productDetailViewNavigate(id: number) {
    if (!id) return;
    const encodedProduct = btoa(JSON.stringify(id)); // Encode entire object as Base64
    this.router.navigate(['/detail-view'], { queryParams: { product: encodedProduct } });
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    })

  }



  getAllProducts() {
    this.spinner.show();
    this.appService.getAllProducts()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: ProductDetails[]) => {
        this.spinner.hide();
        console.log("Get All Products", data);
        this.productDetails = data.filter((item) => item.availability != 'No').sort((a, b) => b.productId - a.productId);
        this.allProductDetails = data.filter((item) => item.availability != 'No').sort((a, b) => b.productId - a.productId);
        // this.categoryDetails = [...new Map(this.productDetails.map((detail) => [detail.categoryDetails.categoryName, detail.categoryDetails])).values()];
        console.log("Filter Category", this.categoryDetails);
      }, (error: any) => {
        console.error("Something Went Wrong", error);
      })
  }


  // category
  getCategoryDetails() {
    this.spinner.show();
    this.appService.getCategoryDetails()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: any) => {
        this.spinner.hide();
        this.categoryDetails = data;
        this.allCategoryDetails = data;
        console.log("Get Category Details::::", this.categoryDetails);
      }, (error: any) => {
        console.error("Something Went Wrong", error);
      })
  }


  getImageId(value: any[]): any {
    const id = value?.find(x => x.isPrimary === true);
    return id ? this.endpoint + `/api/product/image-details/get/${id.imageDetailsId}` : '../../../assets/img/new/athulya-agencies.png'; // Fallback to default if no primary image is found
  }





  changeCategory(catId) {
    console.log("catisissisiis", catId)
    this.isCategorySelected = true;
    this.selectedCategoryId = catId;
    this.filterProducts();
  }

  showAllCategories() {
    console.log('All');
    this.isCategorySelected = false;
    this.selectedCategoryId = 'all';
    this.filterProducts();
  }

  onSearchProduct(query: string) {
    this.productSearchQuery = query;
    this.filterProducts();
    
    if (query && !this.hasScrolledToSearch) {
      this.hasScrolledToSearch = true;
      this.scrollToProducts();
    } else if (!query) {
      this.hasScrolledToSearch = false;
    }
  }

  scrollToProducts() {
    const element = document.getElementById('products-section');
    if (element) {
      const offset = 100; // Account for fixed navbar
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  }

  filterProducts() {
    let filtered = [...this.allProductDetails];

    // Filter by Category
    if (this.selectedCategoryId !== 'all') {
      filtered = filtered.filter(it => it.categoryDetails.categoryId === this.selectedCategoryId);
    }

    // Filter by Search Query
    if (this.productSearchQuery) {
      const q = this.productSearchQuery.toLowerCase();
      filtered = filtered.filter(it => 
        it.productName.toLowerCase().includes(q) || 
        it.productCode?.toLowerCase().includes(q) ||
        it.categoryDetails?.categoryName?.toLowerCase().includes(q)
      );
    }

    this.productDetails = filtered;
  }

  onSearchCategory(query: string) {
    this.categorySearchQuery = query;
    if (!query) {
      this.categoryDetails = [...this.allCategoryDetails];
      return;
    }
    const q = query.toLowerCase();
    this.categoryDetails = this.allCategoryDetails.filter(cat => 
      cat.categoryName.toLowerCase().includes(q)
    );
  }



}
